import * as React from "react";

const VideoIcon = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="#fff" d="M0 0h24v24H0z" />
    <path
      d="M16.014 5.5c.266 0 .52.086.708.238a.744.744 0 0 1 .293.574v3.413l5.218-2.966a.6.6 0 0 1 .518-.028c.082.035.15.087.198.15a.35.35 0 0 1 .072.212v9.814a.35.35 0 0 1-.072.212.474.474 0 0 1-.197.15.6.6 0 0 1-.519-.028l-5.218-2.966v3.412a.744.744 0 0 1-.293.575 1.13 1.13 0 0 1-.708.238H2.001a1.13 1.13 0 0 1-.708-.238.744.744 0 0 1-.293-.575V6.313c0-.215.105-.422.293-.574a1.13 1.13 0 0 1 .708-.238h14.013ZM7.406 9.424a.461.461 0 0 0-.253.073.322.322 0 0 0-.14.187l-.007.064v4.503c0 .052.015.104.046.15.03.047.073.087.127.117a.487.487 0 0 0 .37.036l.072-.029 4.36-2.252a.369.369 0 0 0 .125-.104.27.27 0 0 0 .035-.282.327.327 0 0 0-.097-.121l-.064-.04-4.359-2.253a.473.473 0 0 0-.215-.05Z"
      fill="currentColor"
    />
  </svg>
);

export default VideoIcon;
